

import { mapGetters } from 'vuex';
// API
import * as apiContributions from '../api/private/contributions';

import errorsMixin from '../mixins/error-handler';

export default {
  name: 'SDetailStreet',
  mixins: [errorsMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
    place: {
      type: String,
      default: '',
    },
    street: {
      type: String,
      default: '',
    },
    hasContribution: {
      type: Boolean,
      default: false,
    },
    contributions: {
      type: Object,
      default: null,
    },
    loadingContributions: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Object,
      default: () => ({}),
    },
    hideAppBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldsRefs: ['contribution-street'],
      editStreet: false,
      waitEditStreet: false,
      newStreet: '',
      contributionValue: false,
      toggleTooltip: false,
      loading: false,
      showDeleteContribution: false,
    };
  },
  computed: {
    ...mapGetters({
      isAuth: 'authToken/isAuth',
      userSecured: 'preferences/userSecured',
    }),
    streetIsValid() {
      // The street contains between 3 and 150 characters
      return this.newStreet.length >= 3 && this.newStreet.length <= 150;
    },
  },
  watch: {
    id() {
      this.closeStreetForm();
    },
    editStreet() {
      if (!this.editStreet) {
        // reset errors when leaving edition
        this.errors$.reset();
        // deactivate hideOnScroll
        this.$emit('update:hide-app-bar', false);
        setTimeout(() => {
          if (!this.visible.street) {
            // scroll to the top of the "street" block if it is not visible
            this.$refs.detailStreet.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            setTimeout(() => {
              // reactivate hideOnScroll
              this.$emit('update:hide-app-bar', true);
            }, 500);
          } else {
            // reactivate hideOnScroll
            this.$emit('update:hide-app-bar', true);
          }
        }, 500);
      }
      this.$emit('has-unsave', this.editStreet);
    },
    isAuth(value) {
      if (!value) {
        this.editStreet = false;
      }
    },
    hasContribution() {
      this.contributionValue = this.hasContribution;
    },
    loadingContributions() {
      if (!this.loadingContributions && this.userSecured && this.waitEditStreet) {
        // After logging in, call the API to get the contribution data
        if (this.contributionValue && this.contributions === null) {
          this.$emit('get-contributions');
          return;
        }
        this.newStreet = this.contributions?.street ? this.contributions.street : this.street;
        this.editStreet = true;
        this.waitEditStreet = false;
        this.$nextTick(() => {
          if (this.$refs['contribution-street']) {
            this.$refs['contribution-street'].focus();
          }
        });
      }
    },
    newStreet() {
      // When the street changes, if it is not set or if it is valid, set the error to false
      if (!this.newStreet || this.streetIsValid) {
        this.errors$.handleError(false, 'contribution', 'street');
      }
    },
  },
  mounted() {
    this.contributionValue = this.hasContribution;
  },
  methods: {
    showLogin() {
      if (!this.userSecured) {
        this.$emit('login');
        this.waitEditStreet = true;
      }
    },
    showStreetForm() {
      this.showLogin();
      if (!this.waitEditStreet) {
        // If they are not yet set, call the API to get the contribution data
        if (!this.newStreet && this.contributionValue && this.contributions === null) {
          this.waitEditStreet = true;
          this.$emit('get-contributions');
          return;
        }
        this.newStreet = this.contributions?.street ? this.contributions.street : this.street;
        this.editStreet = true;
        this.$nextTick(() => {
          if (this.$refs['contribution-street']) {
            this.$refs['contribution-street'].focus();
          }
        });
      }
    },
    closeStreetForm() {
      this.editStreet = false;
      this.waitEditStreet = false;
      this.newStreet = '';
    },
    editStreetForm() {
      // prevalidation
      this.errors$.reset();
      this.errors$.handleError(!this.streetIsValid, 'contribution', 'street');

      if (this.errors$.hasErrors()) {
        this.errors$.focusFirstError();
        return;
      }

      this.loading = true;
      const data = {
        playground: this.id,
        street: this.newStreet,
      };
      apiContributions.contribution(data, this).then(() => {
        this.closeStreetForm();
        this.contributionValue = true;
        this.$emit('contribution', data.street);
      }).catch((error) => {
        // No change on this field. Just close the form
        if (this.errors$.getCode('contribution', 'form') === 'no_change') {
          this.closeStreetForm();
          return;
        }

        // Validation error
        if (error.response && error.response.status === 400) {
          if (this.errors$.hasErrors()) {
            this.errors$.focusFirstError();
            return;
          }
          this.errors$.handleError(true, 'contribution', 'form');
          this.$nextTick(() => {
            this.$refs['contribution-form'].$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    deleteContribution() {
      this.closeStreetForm();
      this.contributionValue = false;
      this.$emit('delete-contribution');
    },
  },
};

